import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { CheckCircle2, AlertCircle, Plus, ArrowRight } from "lucide-react";
import { formatCurrency } from "./goalFormat";

const MILESTONES = [25, 50, 75, 100];

export const MilestonesCard = ({ revenueGoal, currentRevenue, onCreate }) => (
  <Card className="glass-card border-gray-800/50 p-6" data-testid="milestones-card">
    <div className="flex items-center justify-between mb-6">
      <h3 className="text-xl font-normal text-white">Milestones</h3>
      <Button onClick={onCreate} variant="ghost" className="text-ism-teal hover:bg-ism-teal/10" data-testid="milestones-create-hierarchy-btn">
        <Plus className="h-4 w-4 mr-1" /> Create Hierarchy
      </Button>
    </div>
    <div className="space-y-4">
      {MILESTONES.map((pct) => {
        const milestoneValue = revenueGoal * (pct / 100);
        const achieved = currentRevenue >= milestoneValue;
        return (
          <div key={pct} className={`flex items-center justify-between p-4 rounded-lg border ${achieved ? "bg-green-500/10 border-green-500/30" : "bg-white/5 border-gray-700/50"}`} data-testid={`milestone-${pct}`}>
            <div className="flex items-center gap-3">
              {achieved ? <CheckCircle2 className="h-6 w-6 text-green-400" /> : <AlertCircle className="h-6 w-6 text-gray-500" />}
              <div>
                <p className="font-normal text-white">{pct}% Milestone</p>
                <p className="text-sm text-gray-400">{formatCurrency(milestoneValue)}</p>
              </div>
            </div>
            {achieved && <Badge className="bg-green-500/20 text-green-400 border-green-500/50">Achieved</Badge>}
          </div>
        );
      })}
    </div>
  </Card>
);

export const RecommendedActions = ({ actions }) => (
  <Card className="glass-card border-red-500/30 p-6" data-testid="recommended-actions-card">
    <h3 className="text-xl font-normal text-white mb-4 flex items-center gap-2">
      <AlertCircle className="h-6 w-6 text-red-400" /> Recommended Actions to Get Back on Pace
    </h3>
    <div className="space-y-3">
      {actions.map((action) => (
        <div key={action} className="flex items-start gap-3 p-3 bg-red-500/10 border border-red-500/30 rounded-lg">
          <div className="p-1 bg-red-500/20 rounded mt-0.5"><ArrowRight className="h-4 w-4 text-red-400" /></div>
          <p className="text-sm text-gray-300 flex-1">{action}</p>
        </div>
      ))}
    </div>
  </Card>
);
